import { AssetDetails } from '@unistocks/features/assets/asset-details';
import { useAssetsGetQuery } from '@unistocks/proxy/axios-client/AssetsQuery';
import { t } from '@unistocks/shared/localization/index.ts';
import { Redirect, useFocusEffect, useLocalSearchParams, useNavigation } from 'expo-router';

import Head from 'expo-router/head';
import { useCallback } from 'react';

export default function AssetDetailsScreen() {
  const navigation = useNavigation();
  const { assetId } = useLocalSearchParams<{ assetId: string }>();
  const { data: asset, isSuccess } = useAssetsGetQuery(assetId);

  useFocusEffect(
    useCallback(() => {
      if (asset) {
        navigation.setOptions({ title: asset.name });
      }
    }, [asset, navigation])
  );

  let title = t('::Asset');
  if (isSuccess) {
    title = `${asset.name} | ${title}`;
  }

  if (!assetId) return <Redirect href={'/'} />;

  return (
    <>
      <Head>
        <title>{title}</title>
      </Head>
      <AssetDetails id={assetId} />
    </>
  );
}
